<template>
  <div class="saved-cards-container">
    <h6 class="section-title">CARTÕES SALVOS</h6>

    <v-list class="cards-list">
      <v-list-item
          v-for="(card, index) in cards"
          :key="card.id"
          class="card-item"
          @click="selectCard(card)"
      >
        <v-list-item-avatar class="card-brand-avatar">
          <v-img
              v-if="getCardBrand(card.card.number).img"
              :src="getCardBrand(card.card.number).img"
              contain
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="card-number">
            {{ formatCardNumber(card.card.number) }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
              icon
              color="error"
              @click.stop="confirmDelete(card)"
          >
            <i class="fas fa-trash"></i>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-list-item class="add-card-item" @click="addNewCard">
        <v-list-item-content>
          <v-list-item-title class="add-card-text">
            <i class="fas fa-plus"></i>
            Adicionar Cartão
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Excluir cartão</v-card-title>
        <v-card-text>
          Deseja excluir o cartão com final {{ selectedCardLast4 }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteCard">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SavedCardsList',
  props: {
    cards: {
      type: Array,
      required: true
    },
    paymentFormId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      deleteDialog: false,
      cardToDelete: null
    };
  },
  computed: {
    selectedCardLast4() {
      if (!this.cardToDelete) {
        return '';
      }
      const number = this.cardToDelete.card.number;
      return number.slice(number.length - 4);
    }
  },
  methods: {
    formatCardNumber(number) {
      const last4 = number.slice(number.length - 4);
      const blur = '*'.repeat(number.length - 4);
      return `${blur} ${last4}`;
    },
    getCardBrand(number) {
      const brands = this.getCreditCardBrands();
      const brand = {
        img: null,
        name: null
      };

      brands.forEach(element => {
        if (number.match(element.include)) {
          brand.img = element.uri;
          brand.name = element.brand;
        }
      });

      return brand;
    },
    getCreditCardBrands() {
      return [
        {
          brand: 'visa',
          include: /^4[0-9]{12}(?:[0-9]{3})?$/,
          uri: require('@/assets/imgs/cards/visa.png')
        },
        {
          brand: 'mastercard',
          include: /^5[1-5][0-9]{14}$/,
          uri: require('@/assets/imgs/cards/master.png')
        },
        {
          brand: 'amex',
          include: /^3[47][0-9]{13}$/,
          uri: require('@/assets/imgs/cards/amex.png')
        },
        {
          brand: 'elo',
          include: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
          uri: require('@/assets/imgs/cards/elo.png')
        }
      ];
    },
    selectCard(card) {
      this.$emit('card-selected', card);
    },
    addNewCard() {
      this.$emit('add-new-card');
    },
    confirmDelete(card) {
      this.cardToDelete = card;
      this.deleteDialog = true;
    },
    async deleteCard() {
      if (!this.cardToDelete) {
        return;
      }

      this.$emit('delete-card', this.cardToDelete.id);
      this.deleteDialog = false;
      this.cardToDelete = null;
    }
  }
};
</script>

<style scoped>
.saved-cards-container {
  margin-top: 15px;
}

.section-title {
  font-size: 12px;
  font-family: Roboto-Light;
  color: #a8a8a8;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.cards-list {
  background: #fff;
  border-radius: 4px;
  padding: 0;
}

.card-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  cursor: pointer;
  transition: background-color 0.2s;
}

.card-item:hover {
  background-color: #f5f5f5;
}

.card-brand-avatar {
  margin-right: 16px !important;
}

.card-number {
  font-family: Roboto-Regular;
  font-size: 16px;
  color: #000;
}

.add-card-item {
  cursor: pointer;
  border-top: 1px dashed #a8a8a8;
  transition: background-color 0.2s;
}

.add-card-item:hover {
  background-color: #f0f0f0;
}

.add-card-text {
  color: #08437B;
  font-family: Roboto-Bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
